import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconCard = ({ t, fill, className, height, width }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox='0 0 39 39'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <title>{t('Card')}</title>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(0 2)'>
        <path fill='#FFF' d='M0 30.837h38.937V5.442H0z' />
        <path fill={fill} d='M0 18.14h38.94v11.85c0 .468-.38.847-.847.847H.847A.847.847 0 0 1 0 29.991V18.14zm0-7.256V6.288c0-.467.38-.846.847-.846h37.246c.467 0 .847.38.847.846v4.596H0zM7.619 27.45a.847.847 0 0 0 0-1.693H4.233a.847.847 0 0 0 0 1.693h3.386zm9.07 0a.847.847 0 0 0 0-1.693h-3.387a.847.847 0 0 0 0 1.693h3.386z' />
      </g>
    </g>
  </svg>
)

export default Icon(IconCard)
